// extracted by mini-css-extract-plugin
module.exports = {"navBack":"NavBack_navBack__3Na8X","customLink":"NavBack_customLink__3y732","arrow":"NavBack_arrow__3A0wL","left":"NavBack_left__GNFg4","customMargin":"NavBack_customMargin__2TlwZ"};